import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'datasources-render-component.cannot-render-text': {
    id: 'datasources-render-component.cannot-render-text',
    defaultMessage: 'Can’t render value',
    description:
      'The text associated with the inability to render content on a database value. This should happen rarely, and only when there is an error retrieving the content'
  }
});
